import type { AiModelNameType } from './generated/inputTypeSchemas/AiModelNameSchema';

export const AI_EMBEDDING_MODEL_NAME_PRISMA_TO_WIRE = {
  TITAN_EMBED_TEXT_V1: 'amazon.titan-embed-text-v1',
  TITAN_EMBED_TEXT_V2: 'amazon.titan-embed-text-v2',
  GEMINI_EMBEDDING_001: 'gemini-embedding-001',
  TEXT_EMBEDDING_004: 'text-embedding-004',
  TEXT_EMBEDDING_005: 'text-embedding-005',
} as const satisfies Partial<Record<AiModelNameType, string>>;

export type AiEmbeddingModelNamePrismaKey =
  keyof typeof AI_EMBEDDING_MODEL_NAME_PRISMA_TO_WIRE;

export const AI_MODEL_NAME_PRISMA_TO_WIRE = {
  CLAUDE_FABLE_5_1: 'claude-fable-5-1',
  CLAUDE_HAIKU_4_5: 'claude-haiku-4-5',
  CLAUDE_HAIKU_5_5: 'claude-haiku-5-5',
  CLAUDE_OPUS_4_8: 'claude-opus-4-8',
  CLAUDE_OPUS_5: 'claude-opus-5',
  CLAUDE_OPUS_5_5: 'claude-opus-5-5',
  CLAUDE_SONNET_4_6: 'claude-sonnet-4-6',
  CLAUDE_SONNET_5: 'claude-sonnet-5',
  CLAUDE_SONNET_5_5: 'claude-sonnet-5-5',
  MYTHOS_PREVIEW: 'mythos-preview',
  MYTHOS_5_1: 'mythos-5-1',
  DEEPSEEK_V4_PRO: 'deepseek-v4-pro',
  GEMINI_3_1_PRO_PREVIEW: 'gemini-3-1-pro-preview',
  GEMINI_3_7_FLASH: 'gemini-3-7-flash',
  GEMMA_4_26B_A4B: 'gemma-4-26b-a4b',
  GEMMA_4_26B_A4B_IT: 'gemma-4-26b-a4b-it',
  GEMMA_4_31B: 'gemma-4-31b',
  GEMMA_4_E2B: 'gemma-4-e2b',
  GROK_4_6: 'grok-4-6',
  GROK_4_7: 'grok-4-7',
  KIMI_K3: 'kimi-k3',
  LLAMA_MAVERICK_4: 'llama-maverick-4',
  NEMOTRON_NANO_3_30B: 'nemotron-nano-3-30b',
  NEMOTRON_SUPER_3_120B: 'nemotron-super-3-120b',
  GPT_5_6_CYBER: 'gpt-5-6-cyber',
  GPT_5_6_LUNA: 'gpt-5-6-luna',
  GPT_5_6_SOL: 'gpt-5-6-sol',
  GPT_5_6_TERRA: 'gpt-5-6-terra',
  GLM_5P3: 'glm-5p3',
} as const satisfies Record<
  Exclude<AiModelNameType, AiEmbeddingModelNamePrismaKey>,
  string
>;

export type AiModelNamePrismaKey = keyof typeof AI_MODEL_NAME_PRISMA_TO_WIRE;
